export enum AuthStorageKeys {
  ACCESS_TOKEN = 'accessToken',
  USER = 'user',
  REMEMBER_ME = 'rememberMe',
}
